module.exports = __webpack_public_path__ + "static/media/DNA-based-Level03.d44e88e6.svg";